import { render, staticRenderFns } from "./messagePanel.vue?vue&type=template&id=464d3f10&lang=pug&"
import script from "./messagePanel.vue?vue&type=script&lang=js&"
export * from "./messagePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports